import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_e74c3c = setTheme(({ theme }) => `background-color: ${theme.colors.color_e74c3c}`);
